import channelcenterapi from '@/api/channelcenter';
import Utils from '@/utils/utils';
import { officialAccountsId } from '@/config';

const checkJSApi = ['checkJsApi'];
const shareApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'];
const imageApiList = ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage'];
const voiceApiList = ['startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice'];
// const smartApiList = ['translateVoice'];
const equipmentInfoApiList = ['getNetworkType'];
// const shakeIbeaconApiList = ['startSearchBeacons', 'stopSearchBeacons', 'onSearchBeacons'];
const interfaceApiList = ['hideOptionMenu', 'showOptionMenu', 'closeWindow', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem'];
const wechatScanApiList = ['scanQRCode'];
// const wechatStoreApiList = ['openProductSpecificView'];

const defaultConfig = {
  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
  appId: '', // 必填，公众号的唯一标识
  timestamp: '',  // 必填，生成签名的时间戳
  nonceStr: '', // 必填，生成签名的随机串
  signature: '', // 必填，签名
  jsApiList: [...checkJSApi, ...shareApiList, ...voiceApiList, ...imageApiList, ...interfaceApiList, ...wechatScanApiList, ...equipmentInfoApiList],
  openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
};

let prevUrl = null;
let timer = null;
let [entryUrl] = location.href.split('#');

// 参考文档
// https://github.com/vuejs/vue-router/issues/481
// https://zhuanlan.zhihu.com/p/32227843
// 列表过长或数据嵌套过深 渲染时和init渲染时机不对 可能出现跳转小程序不生效 ，修改delayed，改变渲染延时时间可以解决
export const init = (encode, delayed = 10) => {
  let [url] = location.href.split('#');
  if(encode) {
    url = encodeURIComponent(url);
  }
  // 避免同一个url连续init多次
  if(url === prevUrl) {
    return;
  } else {
    timer && window.clearInterval(timer);
    prevUrl = url;
  }

  timer = window.setTimeout(function() {
    if(entryUrl === '') {
      entryUrl = url;
    }

    url = Utils.browser().android ? url : entryUrl;
    channelcenterapi.getSDKParamByOffId({ url: url, offId: officialAccountsId })
      .then(config => {
        wx.config(Object.assign({}, defaultConfig, config));
        wx.ready();
        wx.error();
      })
      .catch(err => console.log(err));
  }, delayed);

};

// wx.ready(() => {
//   wx.stopRecord({
//     success: function(res) {
//     }
//   });
// });

// wx.error((res) => {
// });

/**分享功能**/
//1.分享给朋友
export const onMenuShareAppMessage = (config) => {
  wx.onMenuShareAppMessage(Object.assign({
    title: 'v2', // 分享标题
    desc: '', // 分享描述
    link: '', // 分享链接
    imgUrl: 'http://192.168.88.106:8080/group1/M00/00/09/wKhYalfFuO-ILv19AADUmexL8wMAAAAAgFruUMAANSx948.png', // 分享图标
    type: '', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    success: function() {
      // 用户确认分享后执行的回调函数
    },
    cancel: function() {
    }
  }, config));
};

//2.分享朋友圈
export const onMenuShareTimeline = (config) => {
  wx.onMenuShareTimeline(Object.assign({
    title: 'v2', // 分享标题
    link: '', // 分享链接
    imgUrl: 'http://192.168.88.106:8080/group1/M00/00/09/wKhYalfFuO-ILv19AADUmexL8wMAAAAAgFruUMAANSx948.png', // 分享图标
    success: function() {
      // 用户确认分享后执行的回调函数
    },
    cancel: function() {
      // 用户取消分享后执行的回调函数
    }
  }, config));
};

//合并分享设置
export const setShareConfig = (messageConfig = {}, timelineConfig) => {
  wx.ready(() => {
    onMenuShareAppMessage(messageConfig);
    onMenuShareTimeline(timelineConfig || messageConfig);
  });
};

// 防止函数连续触发
const valve = (func) => {
  return (...args) => {
    if(func.operating) {
      return null;
    }

    func.operating = true;
    func(() => {
      func.operating = false;
    }, ...args);
  };
};

/**音频接口**/
//1.开始录音接口
export const startRecord = valve((reset, callback, fail) => {
  wx.startRecord({
    success: function() {
      callback && callback();
    },
    fail: function() {
      fail && fail();
      wx.stopRecord();
      alert('点击刷新试试，刷新页面内容不丢失');
      window.location.reload();
    },
    complete: reset
  });
}, 'startRecord');

//2.停止录音接口
export const stopRecord = valve((reset, callback, fail) => {
  wx.stopRecord({
    success: function(res) {
      let localId = res.localId;
      callback && callback(localId);
    },
    fail: function(e) {
      fail && fail();
      // alert(`stopRecord fail: ${JSON.stringify(e)}`);
    },
    complete: reset
  });
});

//3.监听录音自动停止接口
export const onVoiceRecordEnd = (callback) => {
  wx.onVoiceRecordEnd({
    // 录音时间超过一分钟没有停止的时候会执行 complete 回调
    complete: function(res) {
      let localId = res.localId;
      callback && callback(localId);
    }
  });
};

//4.播放语音接口
export const playVoice = (localId = '') => {
  wx.playVoice({
    localId: localId // 需要播放的音频的本地ID，由stopRecord接口获得
  });
};

//5.暂停播放接口
export const pauseVoice = (localId = '') => {
  wx.pauseVoice({
    localId: localId // 需要暂停的音频的本地ID，由stopRecord接口获得
  });
};

//6.停止播放接口
export const stopVoice = (localId = '') => {
  wx.stopVoice({
    localId: localId // 需要停止的音频的本地ID，由stopRecord接口获得
  });
};

//7.监听语音播放完毕接口
export const onVoicePlayEnd = (callback) => {
  wx.onVoicePlayEnd({
    success: function(res) {
      let localId = res.localId; // 返回音频的本地ID
      callback && callback(localId);
    }
  });
};

//8.上传语音接口
export const uploadVoice = valve((reset, { localId = '', isShowProgressTips = 1, callback }) => {
  wx.uploadVoice({
    localId: localId, // 需要上传的音频的本地ID，由stopRecord接口获得
    isShowProgressTips: isShowProgressTips, // 默认为1，显示进度提示
    success: function(res) {
      let serverId = res.serverId; // 返回音频的服务器端ID
      callback && callback(serverId);
    },
    complete: reset
  });
});

//9.下载语音接口
export const downloadVoice = valve((reset, { serverId = '', isShowProgressTips = 1, callback }) => {
  wx.downloadVoice({
    serverId: serverId, // 需要下载的音频的服务器端ID，由uploadVoice接口获得
    isShowProgressTips: isShowProgressTips, // 默认为1，显示进度提示
    success: function(res) {
      let localId = res.localId; // 返回音频的本地ID
      callback && callback(localId);
    },
    complete: reset
  });
});

//调起微信扫一扫接口
export const scanQRCode = (callback) => {
  wx.scanQRCode({
    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
    success: function(res) {
      callback && callback(res);
    }
  });
};
/**
 * 为了防止页面onload的路由跳转导致微信config失败，需要将该路由跳转操作写在wx.ready的回调中，
 * 为了防止config失败导致路由无法跳转，error后也会执行callback方法
 * **/
export const ready = (callback) => {
  if(Utils.browser().wechat) {
    wx.ready(callback);
    wx.error(callback);
  } else {
    callback();
  }
};
